export default __webpack_public_path__ + "static/media/WM0390.34I-43616_-26034_0.83e8297a.jpg";